"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const clubWebSocket_1 = require("helpers/clubWebSocket");
const UiService_1 = __importDefault(require("modules/ui/UiService"));
const UserService_1 = __importDefault(require("modules/user/UserService"));
const AIContentContext_1 = require("./AIContentContext");
const AIContentStructureService_1 = __importDefault(require("./services/AIContentStructureService"));
const CONTEXT_NAME = 'AICourseStructure';
const useAIContentSocket = ({ onNextStep, onPreviousStep }) => {
    const { subject, setModules } = (0, AIContentContext_1.useAIContentContext)();
    (0, react_1.useEffect)(() => {
        const handleError = () => {
            UiService_1.default.setAlertError('error_try_again');
            onPreviousStep();
        };
        const handleMessage = (response) => {
            var _a;
            if (response.status === clubWebSocket_1.StatusResponse.Success) {
                try {
                    const modules = ((_a = response.message) === null || _a === void 0 ? void 0 : _a.modules) || [];
                    const newModules = modules.map(({ title, pages }, index) => ({
                        id: String(index),
                        title,
                        totalPages: pages === null || pages === void 0 ? void 0 : pages.length,
                        pages: pages === null || pages === void 0 ? void 0 : pages.map(({ title, description }, index) => ({
                            id: String(index),
                            title,
                            description
                        }))
                    }));
                    setModules(newModules);
                    onNextStep();
                }
                catch (error) {
                    handleError();
                }
            }
        };
        const contextId = clubWebSocket_1.ClubWebSocketUtil.generateContextId();
        const postSuggestion = async () => {
            await AIContentStructureService_1.default.postSuggestion({
                language: UserService_1.default.language,
                callbackContextId: contextId,
                subject
            });
        };
        const clubWebSocket = new clubWebSocket_1.ClubWebSocket({
            contextId,
            contextName: CONTEXT_NAME,
            onMessage: handleMessage,
            onError: handleError
        });
        postSuggestion();
        return clubWebSocket.close;
    }, [subject, setModules, onPreviousStep, onNextStep]);
};
exports.default = useAIContentSocket;
